import { DOCUMENT, ViewportScroller } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { concatLatestFrom } from '@ngrx/operators';
import { Store } from '@ngrx/store';
import { delay, filter, map, tap } from 'rxjs/operators';
import { ScrollService } from '@innogy/utils-deprecated';

import {
  confirmInsulationProductSelectionAction,
  onInsulationFunnelNavigationAction,
  selectInsulationFunnelSettings,
} from '../insulation-funnel';
import { showInsulationProductOverviewAction } from './insulation-product-overview.actions';
import { insulationProductOverviewKey } from './insulation-product-overview.reducer';

@Injectable()
export class InsulationProductOverviewEffects {
  funnelSettings$ = this.store$.select(selectInsulationFunnelSettings);

  constructor(
    private readonly actions$: Actions,
    private readonly store$: Store,
    @Inject(DOCUMENT)
    private readonly document: Document,
    private readonly scrollService: ScrollService,
    private readonly viewportScroller: ViewportScroller
  ) {}

  public readonly showInsulationProductOverview$ = createEffect(() =>
    this.actions$.pipe(
      ofType(onInsulationFunnelNavigationAction),
      concatLatestFrom(() => this.funnelSettings$),
      filter(
        ([action, funnelSettings]) =>
          action.page === funnelSettings.productOverviewPage
      ),
      map(showInsulationProductOverviewAction)
    )
  );

  public readonly scrollToProductOverview$ = createEffect(
    () =>
      this.actions$.pipe(
        ofType(showInsulationProductOverviewAction),
        delay(250),
        tap(() => {
          const productOverviewElement = this.document.getElementById(
            insulationProductOverviewKey
          );

          const offset = this.scrollService.getElementVerticalOffset(
            productOverviewElement?.closest?.('wl-dynamic-row')
          );

          if (typeof offset !== 'undefined') {
            this.viewportScroller.scrollToPosition([0, offset]);
          }
        })
      ),
    { dispatch: false }
  );

  public readonly navigateToOrderPageOnSelectProduct$ = createEffect(() =>
    this.actions$.pipe(
      ofType(confirmInsulationProductSelectionAction),
      concatLatestFrom(() => this.funnelSettings$),
      map(([_, { orderPage }]) =>
        onInsulationFunnelNavigationAction({ page: orderPage })
      )
    )
  );
}
